import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantSignUpService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_ParticipantSignUp_ParticipantOnboardInfoDto,
} from '../../services/wealthlane-customer-services';
import { useSelector } from 'react-redux';
import { selectTenantId } from '../../pages/configuration/participantSignupSlice';

const useGetParticipantOnboardingDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  token: string | null
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_ParticipantSignUp_ParticipantOnboardInfoDto | undefined,
  unknown
> => {
  const id = useSelector(selectTenantId);
  const participantOnboardingDetails = useQuery(
    ['getParticipantOnboardingDetails', token, id],
    async () => {
      if (token != null && id !== null) {
        return await handleRequest(
          ParticipantSignUpService.getApiCustomerApiAppParticipantSignUpParticipantOnboardingDetails()
        );
      }
    },
    {
      enabled:
        typeof token === 'string' && token != null && token !== '' && id != null && id !== '',
    }
  );

  return participantOnboardingDetails;
};

export default useGetParticipantOnboardingDetails;
